import { render, staticRenderFns } from "./americaLabel.vue?vue&type=template&id=853f8fce&scoped=true&"
import script from "./americaLabel.vue?vue&type=script&lang=js&"
export * from "./americaLabel.vue?vue&type=script&lang=js&"
import style0 from "./americaLabel.vue?vue&type=style&index=0&id=853f8fce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "853f8fce",
  null
  
)

export default component.exports